import { createPortal } from "react-dom"
import { useInspectorContext } from "~/components/design-system/pages/internal/InspectorContext"

/**
 * Sticky footer for the inspector: the one primary action on the item on show (set a quantity and
 * send it on, say), pinned below the views so it never scrolls away.
 *
 * Render it anywhere inside the inspector content; it portals into the chrome, so it stays live
 * with the owner's props and shows on every tab and drilldown level. Children lay out in a row.
 * Nothing rendered means no footer, rule or spacing.
 *
 * Not for secondary actions or cards — those belong in an `InspectorCard`.
 */
const InspectorFooter = ({ children }: { children: React.ReactNode }) => {
  const { footerEl } = useInspectorContext()
  return footerEl ? createPortal(children, footerEl) : null
}

export default InspectorFooter
